import React from 'react'

const CTA = () => {
  return (
    <div className="cta">
      <a
        href="https://harshsingh-io.github.io/resume/"
        target="_blank"
        rel="noreferrer"
        className="btn"
      >
        View Resume
      </a>
      <a href="#contact" className="btn btn-primary">
        Contact Me
      </a>
    </div>
  )
}

export default CTA
